export default {
      id: "Icon--exoticProvisional-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--exoticProvisional",
      toString: function () {
        return this.url;
      }
    }